import * as React from "react"
import Svg, { Path } from "react-native-svg"

function SvgComponent(props) {
  return (
    <Svg
      width={20}
      height={20}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <Path
        d="M13.188 6.499a.877.877 0 01-.863.72h-4.65a.873.873 0 01-.863-.72l-.02-.114H2.184l.81 9.253a.35.35 0 00.35.322h3.02c.089 0 .162-.029.231-.09l.92-.818a.71.71 0 01.492-.187h3.988a.71.71 0 01.492.187l.92.818c.069.061.142.09.232.09h3.02a.35.35 0 00.35-.322l.805-9.25h-4.607l-.02.11zm-7.1 8.582H4.276a.488.488 0 01-.489-.448l-.154-1.766a.196.196 0 01.179-.212c.11-.008.203.07.211.18L4.18 14.6c.004.05.045.09.098.09h1.81a.195.195 0 010 .39zm10.36-7.634a.196.196 0 01.211-.18.199.199 0 01.18.212l-.326 3.712a.199.199 0 01-.212.178.199.199 0 01-.179-.211l.326-3.711z"
        fill="#919191"
      />
      <Path
        d="M7.194 6.43c.045.236.24.398.48.398h4.647c.24 0 .436-.162.48-.398l.44-2.389H6.755l.44 2.389zm.61-1.189H12.2a.195.195 0 010 .391H7.805a.195.195 0 01-.196-.195c0-.11.086-.196.196-.196zM6.36 4.041H1.693a.25.25 0 00-.248.248v1.465c0 .134.11.248.244.248h5.03L6.36 4.041zM18.311 4.041h-4.667l-.362 1.957h5.03c.133 0 .243-.11.243-.244V4.29a.246.246 0 00-.244-.248z"
        fill="#919191"
      />
    </Svg>
  )
}

export default SvgComponent
